module.exports = __webpack_public_path__ + "static/img/mobilefull.d3ed931.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/mytronics/mobilefull.png
// module id = 3G+h
// module chunks = 0